import styled from 'styled-components';

const ImageContainer = styled.img`
  max-width: 100%;
  object-fit: contain;
`;

export default ImageContainer;
